export { ThemeProvider as default } from '@material-ui/system';